var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFavoritesFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.415 94.7801H57.585L27.7575 54.3301C23.4875 48.5401 22.8075 40.8926 25.98 34.3701C29.0375 28.0851 34.9325 24.2101 41.7475 24.0076C41.95 24.0026 42.1525 23.9976 42.3575 23.9976C49.485 23.9976 55.3375 27.6601 59.2775 34.5901C59.535 35.0426 59.775 35.4926 60 35.9426C60.225 35.4951 60.465 35.0426 60.7225 34.5901C64.6625 27.6601 70.5125 23.9976 77.6425 23.9976C77.8475 23.9976 78.05 24.0001 78.2525 24.0076C85.0675 24.2101 90.9625 28.0851 94.02 34.3701C97.1925 40.8901 96.51 48.5401 92.2425 54.3301L62.415 94.7801Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFavoritesFilled);
export default __webpack_public_path__ + "static/media/HeartFavorites_Filled.4bd80566.svg";
export { ForwardRef as ReactComponent };